export default __webpack_public_path__ + "static/enablement-015ca898442c65e0909adb725bc54dbc.webp";